import {
  Required,
  IsString,
  IsNumber,
  IsBoolean,
  DataValidator,
  transformKeys,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

export interface VideoUserActorTemplateResponse {
  id: string;
  model_id: string;
  name: string;
  gender: string;
  age_group: string;
  is_hd: boolean;
  is_pro: boolean;
  is_exclusive_pro: boolean;
  is_free_speech: boolean;
  situation?: string;
  image_url: string;
  compressed_actor_default_video_url?: string;
  full_actor_default_video_url?: string;
  sort_order: number;
  is_favorite: boolean;
  is_my_actor: boolean;
  is_free: string;
  tags?: Array<string>;
  generate_status: number;
  default_audio: Default_Audio;
};

export interface Default_Audio {
  id: string;
  type: number;
  actor_id: string;
  voice_tts_id: string;
  model_name: string;
  name: string;
  age_group: string;
  language: string;
  emotion: string;
  gender: string;
  speed: number;
  audio_url: string;
  duration: number;
  is_starred: boolean;
  is_selected: boolean;
  sort_order: number;
  use_count: number;
};

export class DefaultAudio {
  @Required("Audio URL cannot be empty")
  @IsString("Audio URL must be a string")
  audioUrl: string;

  @Required("ID cannot be empty")
  @IsString("ID must be a string")
  id: string;

  @Required("Is starred cannot be empty")
  @IsBoolean("Is starred must be a boolean")
  isStarred: boolean;

  @Required("Model name cannot be empty")
  @IsString("Model name must be a string")
  modelName: string;

  @Required("Name cannot be empty")
  @IsString("Name must be a string")
  name: string;

  @Required("Speed cannot be empty")
  @IsNumber("Speed must be a number")
  speed: number;

  @Required("Voice TTS ID cannot be empty")
  @IsString("Voice TTS ID must be a string")
  voiceTtsId: string;

  @Required("Age group cannot be empty")
  @IsString("Age group must be a string")
  ageGroup: string;

  @Required("Language cannot be empty")
  @IsString("Language must be a string")
  language: string;

  @Required("Gender cannot be empty")
  @IsString("Gender must be a string")
  gender: string;
}

// actors 嵌套类
export class VideoUserActorTemplateData {
  @Required("ID cannot be empty")
  @IsString("ID must be a string")
  id: string;

  @Required("Name cannot be empty")
  @IsString("Name must be a string")
  name: string;

  // @Required("modelName cannot be empty")
  @IsString("modelName must be a string")
  modelName: string;

  @Required("imageUrl cannot be empty")
  @IsString("imageUrl must be a string")
  imageUrl: string;

  @Required("generateStatus cannot be empty")
  @IsNumber("generateStatus status must be a number")
  generateStatus: number;

  @IsString("fullActorDefaultVideoUrl must be a string")
  fullActorDefaultVideoUrl: string;

  @IsString("createdAt must be a string")
  createdAt: string;

  @IsString("compressedActorDefaultVideoUrl must be a string")
  compressedActorDefaultVideoUrl: string;

  @IsString("gender must be a string")
  gender: string;

  // @Required("defaultAudio cannot be empty")
  @ValidateNested(DefaultAudio)
  defaultAudio: DefaultAudio[]; // 轮询中可能为空
}

const transformAndValidateData = (
  response: VideoUserActorTemplateResponse
): VideoUserActorTemplateData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, VideoUserActorTemplateData);
  } catch (error) {
    console.error("Video user actor template data validation failed:", error.message);
    throw error;
  }
};

/** 轮训查看数字人状态 */
export const videoUserActorTemplate = async (id: string) => {
  const response = await api.get<VideoUserActorTemplateResponse>(`video/user-actor-template/${id}`)
  const data = transformAndValidateData(response.data);
  return data;
}